var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSysAttention(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EB6E23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14,9.74339623 C14,8.78113208 14.8956193,8 16,8 C17.1043807,8 18,8.78113208 18,9.74339623 L18,16.2556604 C18,17.2188679 17.1043807,18 16,18 C14.8956193,18 14,17.2188679 14,16.2556604 L14,9.74339623 Z M15.999493,24 C14.8963245,24 14,23.1042354 14,22.0005072 C14,20.8957646 14.8963245,20 15.999493,20 C17.1046895,20 18,20.8957646 18,22.0005072 C18,23.1042354 17.1046895,24 15.999493,24 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSysAttention);
export default __webpack_public_path__ + "static/media/ic_sys_attention.41f8f5a806826d6cac89407363779b16.svg";
export { ForwardRef as ReactComponent };